import React, { useState, useEffect } from "react";
import { Grid, Text, InlineStack, Button } from "@shopify/polaris";
import { Select } from "@shopify/polaris";
import { useNavigate, useLocation } from "react-router-dom";

import InfoCard from "../../components/Common/InfoCard.jsx";
import OrderTable from "../../components/Dashboard/OrderTable.jsx";
import { GetOrderOverview, GetOrders } from "../../services/order/index.js";
import useOrderStore from "../../store/order/index.js";
import EmptyState from "../../components/Common/EmptyState.jsx";
import useBundlesStore from "../../store/bundle/index.js";
import { GetBundles } from "../../services/bundle/index.js";

const filers = [
  {
    filterName: "Payment Status",
    filter: "paymentStatus",
    filterValue: [
      { label: "Select", value: null },

      { label: "Paid", value: "paid" },
      { label: "Pending", value: "pending" },
      { label: "Refunded", value: "refunded" },
    ],
  },
  {
    filterName: "Order Status",
    filter: "status",
    filterValue: [
      { label: "Select", value: null },
      { label: "Fulfilled", value: "fulfilled" },
      { label: "Pending", value: "pending" },
      { label: "Cancelled", value: "cancelled" },
    ],
  },
];
const OrdersDashboard = () => {
  const { orders, setOrders } = useOrderStore();
  const [currentPage, setCurrentPage] = useState(1);
  const { bundles, setBundles } = useBundlesStore();
  const [salesSummary, setSalesSummary] = useState([
    { label: "Total", value: "-" },
    { label: "Pending", value: "-" },
    { label: "Delivered", value: "-" },
  ]);
  const [filters, setFilters] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const capitalizeUnderscoreString = (str) => {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const addQueryParam = (key, value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(key, value);
    navigate({ search: searchParams.toString() });
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };

  const removeQueryParam = (key) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete(key);
    navigate({ search: searchParams.toString() });
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      delete newFilters[key];
      return newFilters;
    });
  };

  const fetchOrders = async () => {
    const searchParams = new URLSearchParams(location.search);
    const filters = {};
    for (const [key, value] of searchParams.entries()) {
      filters[key] = value;
    }

    const filterString = Object.entries(filters)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    const { data } = await GetOrders(currentPage, filterString);
    // if (data?.result?.length) {
    setOrders(data.result ?? []);
    // }
  };

  const fetchBundles = async () => {
    if (!bundles.length) {
      const { data } = await GetBundles(currentPage);
      if (data?.result) {
        setBundles(data.result);
      }
    }
  };

  const fetchOrdersOverview = async () => {
    const { data } = await GetOrderOverview();
    if (data.result?.salesSummary && data.result?.orderSummary) {
      setSalesSummary(
        Object.entries(data.result?.orderSummary).map(([key, value]) => {
          return {
            label: capitalizeUnderscoreString(key),
            value,
          };
        })
      );
    }
  };
  useEffect(() => {
    fetchOrders();
    fetchBundles();
    fetchOrdersOverview();
  }, [currentPage, filters]);
  console.log(orders);

  const resetFilters = () => {
    navigate({ search: "" });
    setFilters({});
  };
  return (
    <>
      {!orders.length ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyState
            heading={"No Orders found"}
            text={
              "Your shop is open, and the first order is just a step away. Start promoting your bundles to kick things off! Or try resetting the filters."
            }
            img="no order found.svg"
            // btnName={""}
            // redirect={"/coupons/create"}
          />
          <Button onClick={resetFilters}>Reset Filters</Button>
        </div>
      ) : (
        <>
          <InlineStack align={"space-between"} wrap={false}>
            <Text as="h3" variant="headingSm">
              Orders
            </Text>
          </InlineStack>
          <Grid columns={{ xs: 1, sm: 1, md: 12, lg: 12, xl: 12 }}>
            {salesSummary.map((order) => {
              return (
                <InfoCard
                  columnSpan={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
                  label={order.label}
                  value={order.value}
                />
              );
            })}
          </Grid>
          <br />
          <InlineStack align={"space-between"} wrap={false}>
            <InlineStack align="space-around" gap="10">
              <Text as="h3" variant="headingSm">
                Order Listing
              </Text>
            </InlineStack>
            <InlineStack align="space-around" blockAlign="center" gap="1000">
              {filers.map((filter) => {
                return (
                  <Select
                    label={filter.filterName}
                    options={filter.filterValue}
                    value={
                      location.search
                        .split("&")
                        .find((item) => item.includes(filter.filter))
                        ?.split("=")[1] || null
                    }
                    onChange={(value) =>
                      value === null
                        ? removeQueryParam(filter.filter)
                        : addQueryParam(filter.filter, value)
                    }
                  />
                );
              })}
              <div>
                <Button onClick={resetFilters}>Remove Filters</Button>
              </div>
            </InlineStack>
          </InlineStack>
          <br />
          <OrderTable
            fetchData={fetchOrders}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            orders={orders}
          />
        </>
      )}
    </>
  );
};

export default OrdersDashboard;
